import React, { useContext } from 'react';
import styled from 'astroturf/react';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { ResponsiveContext, ScreenSize } from '../shared/Responsive';

export interface Props {
  description: string[];
}

const Header = styled.h2`
  @import '../shared/mixins.scss';
  @include subheadBold();
  margin-top: 0;
  margin-bottom: 20px;
  color: #222222;
  opacity: 0.9;
`;

const ListItem = styled.div`
  @import '../shared/mixins.scss';
  @include bodyMediumRegular();
  @include textPrimary();
  opacity: 0.9;
  display: flex;
  align-items: flex-start;

  > span {
    flex-grow: 1;
  }
`;

const CheckMark = styled.span`
  color: #0954d3;
  font-weight: 900;
  line-height: 18px;
  flex-grow: 0;
  flex-shrink: 1;
  margin-right: 13px;
`;

const ListContainer = styled.div<{ singleColumn?: boolean }>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 16px;
  grid-column-gap: 30px;
  justify-items: start;

  &.singleColumn {
    grid-template-columns: 1fr;
    grid-column-gap: 0;
  }
`;

const LearningPoints: React.FunctionComponent<Props> = ({ description }) => {
  const { screenSize } = useContext(ResponsiveContext);
  const isMobile = screenSize === ScreenSize.Mobile;
  const isTablet = screenSize === ScreenSize.Tablet;

  return (
    <>
      <Header>What you’ll learn from this Course</Header>
      <ListContainer singleColumn={isMobile || isTablet}>
        {description.map((feature, index) => (
          <ListItem key={index}>
            <CheckMark>
              <FontAwesomeIcon icon={faCheck} />
            </CheckMark>
            <span>{feature}</span>
          </ListItem>
        ))}
      </ListContainer>
    </>
  );
};

export default LearningPoints;
